<style scoped lang="less">
@import "/lib/Colors.less";
.overlayContainer {
    position: relative;
    .overlay {
        display: flex;
        align-items: center;
        margin: auto;
        z-index: 3;
        .overlayCenter {
            text-align: center;
            z-index: 5;
            opacity: 1;
            box-shadow: 0 0 50px 50px #ffffff;
            background: #ffffff;
            padding: 15px;
            max-width: 450px;
        }
    }
}
@added: #208337;
@changed: #2568db;
@deleted: #d70015;
.adminDiffControlContainer {
    padding: 10px 15px;
    .changedKey,
    .deletedKey,
    .addedKey {
        color: white;
    }
    .changedKey {
        background: @changed;
    }
    .deletedKey {
        background: @deleted;
    }
    .addedKey {
        background: @added;
    }
}

.changed,
.deleted,
.new {
    border-style: dashed;
    border-width: 2px;
}
.changed {
    border-color: @changed !important;
}
.deleted {
    border-color: @deleted !important;
}
.new {
    border-color: @added !important;
}
.df-workflow-title {
    display: block;
    color: #687078;
    font-size: 0.6em;
}
.df-form-title {
    font-size: 26px;
}
.df-segment-title {
    display: block;
    margin-bottom: 7.5px;
}
.save-all-container {
    position: sticky;
    top: -10px;
    margin-top: -40px;
    margin-left: auto;
    padding: 0 15px;
    z-index: 10001;
}
.btn-outline-secondary:not(:hover):not(:focus) {
    background-color: #ffffff;
}
.alert-issues {
    background: @warning;
    color: #000;
    font-weight: 600;
}
[role="tablist"] {
    .list-group-item {
        &.disabled {
            color: #6c757d;
            pointer-events: none;
            background-color: #fff;
        }
        &[tabindex="-1"]:focus {
            outline: 1px dotted !important;
            outline: 5px auto -webkit-focus-ring-color !important;
        }
    }
}
</style>
<style lang="less">
@gap: 0.5em;
.df-navigation-btn-container {
    display: grid;
    gap: @gap;
    grid-template-columns: repeat(auto-fit, minmax(0, min-content));
    align-items: start;
    justify-content: space-between;
    grid-template-areas: "previous delete exit submit next";

    button,
    a {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: unset !important;
    }
    .df-save-and-exit-btn {
        grid-area: exit;
    }
    .df-previous-btn {
        grid-area: previous;
    }
    .df-save-and-continue-btn {
        grid-area: next;
    }
    .df-delete {
        grid-area: delete;
    }
    .df-submit-btn-container {
        grid-area: submit;
        display: flex;
        gap: @gap;
        flex-wrap: wrap;
        justify-content: end;
    }
}
.button-condensed {
    .df-navigation-btn-container,
    .df-submit-btn-container {
        display: flex;
        gap: @gap;
        flex-direction: column;
        justify-content: center;

        button,
        a {
            width: 100%;
            margin: 0 !important;
        }
    }
    .df-submit-btn-container {
        width: 100%;
    }
}
</style>
<template>
    <form class="row overlayContainer" @submit.prevent="advanceForm" :class="{ 'condensed-side': condensed, 'button-condensed': buttonCondensed }" ref="Form">
        <div v-if="hasIssues" class="alert alert-issues text-center p-1 m-0 w-100">Submission cannot be continued until issues are resolved.</div>
        <input class="d-none" type="submit" value="Advance Form" />
        <div class="save-all-container">
            <button type="button" class="btn btn-secondary save-all-button" @click.prevent="saveAllAdminEdits" v-if="hasPendingAdminEdits">Save All Revisions</button>
        </div>
        <div class="col-12">
            <!--
            {{ segment }}
            {{ activeSegments.map(i => i.id) }}
            {{ availableSegments.map(i => i.id) }}
            {{ isPendingAssignment }}
            -->
            <div>
                <h1 id="df-form-title" class="df-form-title" ref="FormTitle">
                    <span class="df-segment-title">{{ segmentTitle }}</span>
                    <span class="df-workflow-title" v-if="isWorkflow && adminReview">{{ title }}</span>
                </h1>
                <h2 class="df-page-title" v-if="hasMultiplePages && currentPage">{{ currentPage.definition.settings.effectiveLinkText }}</h2>
                <p class="df-page-sub" v-if="currentPage && currentPage.definition.settings.description">{{ currentPage.definition.settings.description }}</p>
            </div>
        </div>
        <div class="overlay" v-if="isPendingAssignment">
            <div class="overlayCenter">
                <SegmentSelector />
            </div>
        </div>
        <div class="col-md-4 col-lg-3 df-public-nav" :class="pageNavCollapsed ? ['df-collapsed'] : []" v-if="hasMultiplePages && showPageNav && !isPendingAssignment" @click.capture="openNav">
            <div class="df-public-nav-pages" id="PageNavigation">
                <div class="list-group" role="navigation" aria-label="Sections">
                    <template v-for="pageGroup in pageGroupCast(pageGroups)">
                        <div role="tablist" aria-orientation="vertical" :aria-labelledby="Object.keys(pageGroups).length > 1 && pageGroup.pages.length >= 1 ? `tab_${pageGroup.id}` : 'df-form-title'" class="list-group-container mb-3">
                            <!-- <pre>{{pageGroup.pages.map(i => pageStatusFetcher()[i.vmId])}}</pre> -->
                            <!-- <pre>{{pageGroupStatus(pageGroup.pages)}}</pre> -->
                            <button v-if="Object.keys(pageGroups).length > 1 && pageGroup.pages.length >= 1" type="submit" role="tab" class="list-group-item page-header-btn w-100" @click.prevent="pageGroup.pages.some(p => (enabledPages || []).includes(p)) && gotoSubPage(pageGroup.pages.find(p => (enabledPages || []).includes(p)) ?? pageGroup.pages[0], true)" @keydown.up.prevent="focusPreviousTab" @keydown.left.prevent="focusPreviousTab" @keydown.down.prevent="focusNextTab" @keydown.right.prevent="focusNextTab" :class="[{ active: pageGroup.pages.some(i => i == currentPage), disabled: pageGroup.pages.every(p => !(enabledPages || []).includes(p)) }, pageGroupStatus(pageGroup.pages)]" :tabindex="pageGroup.pages.some(i => i == currentPage) ? 0 : -1" :id="`tab_${pageGroup.id}`" :aria-selected="pageGroup.pages.some(i => i == currentPage)" :aria-disabled="pageGroup.pages.every(p => !(enabledPages || []).includes(p))" :aria-expanded="togglePageHeader[pageGroup.id!]">
                                <span class="btn-wrapper d-flex justify-content-between align-items-center">
                                    <i class="page-header-status page-status-icon d-flex" aria-hidden="true"></i>
                                    <span class="flex-grow-1">{{ pageGroup.label }}</span>
                                    <i class="sr-only">{{ pageGroup.pages.map(p => pageStatus(pageStatusFetcher()[p.vmId])).reduce((a, i) => (a == i ? a : null)) }}</i>
                                    <i class="icon ml-2" :class="togglePageHeader[pageGroup.id!] ? 'icon-caret-down' : 'icon-caret-right'" aria-hidden="true"></i>
                                </span>
                            </button>
                            <template v-if="(currentPage == null || pageGroup.pages.some(i => i == currentPage) || pageGroup.pages.length <= 1) && togglePageHeader[pageGroup.id!]">
                                <template v-for="page in pageGroup.pages">
                                    <button class="list-group-item w-100" role="tab" type="submit" @click.prevent="(enabledPages || []).includes(page) && gotoSubPage(page)" @keydown.up.prevent="focusPreviousTab" @keydown.left.prevent="focusPreviousTab" @keydown.down.prevent="focusNextTab" @keydown.right.prevent="focusNextTab" :class="[{ active: currentPage == page, disabled: !(enabledPages || []).includes(page) }, pageStatusClass(pageStatusFetcher()[page.vmId]), !showChanges ? {} : page.baseChangeRecursive() != null ? page.baseChangeRecursive() : {}]" :tabindex="currentPage == page ? 0 : -1" :id="`tab_${page.vmId}`" :aria-selected="currentPage == page" :aria-disabled="!(enabledPages || []).includes(page)" aria-controls="jsPageEditor">
                                        <span class="btn-wrapper d-flex align-items-center">
                                            <i class="page-status-icon d-flex" aria-hidden="true"></i>
                                            <span class="flex-grow-1">{{ page.definition.settings.effectiveLinkText }}</span>
                                            <i class="sr-only">{{ pageStatus(pageStatusFetcher()[page.vmId]) }}</i>
                                        </span>
                                    </button>
                                </template>
                            </template>
                        </div>
                    </template>
                </div>
            </div>
            <div class="mb-3">
                <div v-if="!isCurrentPageViewOnly" class="d-none d-md-block">
                    <template v-if="!!submitButtons && submitButtons.length <= 1">
                        <button v-for="submitButton in submitButtons" class="btn btn-primary dfNavButton cancel mb-1 mr-1" name="saveType" :disabled="!isSubmittable" type="submit" value="ConfirmSubmitForm" @click.prevent="submit(submitButton.trigger, $event)" :title="submitButton.text ?? undefined">
                            {{ submitButton.text }}
                        </button>
                    </template>
                    <button class="btn btn-outline-secondary cancel dfNavButton ml-1 mb-1" type="button" :disabled="!isDeletable" @click.prevent="deleteDraft(false, $event)">Delete</button>
                </div>
            </div>
        </div>
        <div v-if="!isPendingAssignment" :class="hasMultiplePages && showPageNav ? ['col-md-8', 'col-lg-9'] : ['col-md-12']">
            <div class="clearfix" id="jsPageEditor" role="tabpanel" :aria-labelledby="`tab_${currentPage?.vmId}`">
                <div class="clearfix" v-if="currentPage" role="main" aria-label="Current Section">
                    <AdminSettingsDifferences :data="currentPage" :pageMode="true" />
                    <component :is="currentPage.definition.type" :data="currentPage" :view-only="isCurrentPageControlsViewOnly"></component>
                </div>
                <div class="text-center df-navigation-btn-container" style="margin-top: 30px" v-show="currentPage != null && !currentPage.hasCustomPageNav()">
                    <button class="btn btn-outline-secondary dfNavButton cancel df-previous-btn" name="editPage" type="submit" value="1" @click.prevent="retreatForm" v-if="hasMultiplePages" :disabled="!canRetreatForm" aria-label="Previous">&lt; Previous</button>
                    <button type="button" class="btn btn-outline-secondary cancel dfNavButton mx-auto" @click.prevent="gotoIndex" v-if="isViewOnly" :disabled="adminPreview ?? undefined">Home</button>
                    <button type="button" class="btn btn-outline-secondary cancel df-delete dfNavButton" v-show="isDeletable" :class="{ 'visible-xs-inline-block': hasMultiplePages }" @click.prevent="deleteDraft(false, $event)" :disabled="adminPreview ?? undefined">Delete</button>
                    <button class="btn btn-outline-secondary dfNavButton cancel df-save-and-exit-btn" name="saveType" type="submit" value="SaveAndExit" @click.prevent="saveAndExit" v-if="!isViewOnly && !isCurrentPageViewOnly" :disabled="adminPreview ?? undefined">Save and Exit</button>
                    <!-- <div class="d-flex flex-wrap flex-grow-1 flex-sm-grow-0 justify-content-end" v-if="!isCurrentPageViewOnly && submittablePages.includes(currentPage)"> -->
                    <div class="df-submit-btn-container" v-if="!isCurrentPageViewOnly && submittablePages.includes(currentPage!)">
                        <!-- group buttons together in UX -->
                        <template v-if="!isCurrentPageViewOnly && submittablePages.includes(currentPage!)">
                            <button v-for="submitButton in submitButtons" class="btn dfNavButton cancel df-save-and-continue-btn" name="saveType" type="submit" value="ConfirmSubmitForm" :class="{ 'btn-primary': !isCurrentPageViewOnly, 'btn-outline-secondary': isCurrentPageViewOnly }" :disabled="!canAdvanceForm" :style="{ float: !hasMultiplePages ? 'none' : undefined }" @click.prevent="submit(submitButton.trigger, $event)" :title="submitButton.text ?? undefined">
                                {{ truncateLongText(submitButton.text) }}
                            </button>
                        </template>
                    </div>
                    <button class="btn dfNavButton cancel df-save-and-continue-btn" name="saveType" type="submit" value="ConfirmSubmitForm" :class="{ 'btn-primary': !isCurrentPageViewOnly, 'btn-outline-secondary': isCurrentPageViewOnly }" :disabled="!canAdvanceForm" :style="!hasMultiplePages ? { float: 'none' } : {}" v-if="(hasMultiplePages || !isCurrentPageViewOnly) && !submittablePages.includes(currentPage!)" @click.prevent="advanceForm" aria-label="Next">Next &gt;</button>
                </div>
                <div class="text-center" style="margin-top: 30px" v-show="currentPage != null && currentPage.hasCustomPageNav()">
                    <button type="button" class="btn btn-outline-secondary cancel" @click.prevent="gotoIndex" :disabled="adminPreview || false">Home</button>
                </div>
            </div>
        </div>
    </form>
</template>
<script lang="ts">
import { defineComponent, ref, onMounted, onBeforeUnmount, onDeactivated, computed, watch, nextTick, inject, provide, SetupContext } from "vue";
import PageDefComponent from "./elementTemplates/PageDef.3.vue";
import AdminSettingsDifferences from "./elementTemplates/AdminSettingsDifferences.3.vue";
import SegmentSelector from "./Page/SegmentSelector.3.vue";
import SaveFailureModal from "./dialogs/SaveFailure.3.vue";
import { useObservable } from "@vueuse/rxjs";
import { computedAsync } from "@vueuse/core";
import { combineLatest } from "rxjs";
import { map, first, switchMap, startWith /*tap*/ } from "rxjs/operators";
import type mitt from "mitt";
import getElementComponent from "./elementTemplates/elementFactory.3";
import { usePageStore, toObserverComputed } from "./pageState/store";
import { useMainStore } from "@/mainStore";
import type PageDef from "./elements/PageDef";
import { BaseElementDefBase } from "./elements/BaseElementDef";
import { BaseFormDefinitionItem } from "./elements/__DefinitionDataInterface";
import { updatePageInjectKey, updatePage, showModalInjectKey, showModal } from "@/AppShell.3.vue.InjectKeys";
import { gotoIndexInjectKey, forceLoginInjectKey, submitInjectKey, deleteDraftInjectKey, pageStatusFetcherInjectKey, /*returnSubmissionInjectKey, startWorkflowManualOverrideInjectKey,*/ submitButtons$InjectKey } from "./Page.3.vue.InjectKeys";
import FormDef from "./elements/FormDef";
import type { FormJson } from "@cs/FormJson";
import type { SaveAllAndSubmitResponse } from "@cs/SaveAllAndSubmitResponse";
import { AbortReason } from "./Page.3.vue";

type PageGroup = {
    id: string | null;
    label: string;
    pages: PageDef[];
};
interface Props {
    pageI: number;
    pageGroups: PageGroup[];
}
export default defineComponent({
    props: ["pageI", "pageGroups"],
    components: {
        PageDef: PageDefComponent,
        AdminSettingsDifferences,
        SegmentSelector,
    },
    emits: ["set-page", "show-page-nav", "current-segment", "current-page"],
    //eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO - figure out why SetupContext gives overload failure
    setup(props: Props, setupContextUntyped: any) {
        const emit = (setupContextUntyped as SetupContext).emit;
        const pageNavCollapsed = ref(false);
        const page = ref(null as null | number);
        const formData$ = ref<FormDef | null>(null!);
        const condensed = ref(false);
        const buttonCondensed = ref(false);
        const mustToggle = ref(false);
        const togglePageHeader = ref({} as Record<string, boolean>);

        const Form = ref(null! as HTMLElement);
        const FormTitle = ref(null! as HTMLElement);

        const pageStore = usePageStore();
        const mainStore = useMainStore();
        const eventBus = inject("pageEventBus") as ReturnType<typeof mitt>;
        const updatePage = inject(updatePageInjectKey) as updatePage;
        const showModal = inject(showModalInjectKey) as showModal;

        const currentPage$ = computed(() => {
            const page$ = toObserverComputed(() => page.value);
            const pages$ = toObserverComputed(() => pageStore.pages);
            return combineLatest([pages$, page$]).pipe(
                map(([pages, page]) => {
                    const currentPage = page == null ? null : pages[page! - 1];
                    emit("current-page", currentPage);
                    return currentPage;
                }),
            );
        });
        const currentPage = useObservable(currentPage$.value);

        const currentSegment$ = computed(() => {
            const segments$ = toObserverComputed(() => pageStore.segments);
            return combineLatest([currentPage$.value, segments$]).pipe(
                map(([currentPage, segments]) => {
                    if (currentPage == null) return null;
                    const currentSegment = segments!.find(i => i.id == currentPage.definition.settings.segment);
                    emit("current-segment", currentSegment);
                    return currentSegment;
                }),
            );
        });
        const currentSegment = useObservable(currentSegment$.value);
        const currentSegmentLabel$ = computed(() => {
            return currentSegment$.value.pipe(
                map(currentSegment => {
                    if (currentSegment == null) return null;
                    return currentSegment.definition.settings.displayLabel;
                }),
            );
        });
        const currentSegmentLabel = useObservable(currentSegmentLabel$.value);

        const enabledPages$ = computed(() => {
            const pageGroupsI = toObserverComputed(() => props.pageGroups);
            return combineLatest([pageStore.enabledPages$, pageGroupsI]).pipe(
                //tap(i => { debugger; }),
                map(([enabledPages, pageGroups]) => {
                    //debugger;
                    return enabledPages.filter(i => pageGroups.some(j => j.pages.includes(i)));
                }),
                //tap(i => { debugger; }),
            );
        });
        const enabledPages = useObservable(enabledPages$.value);
        const pages = computed(() => pageStore.pages);
        const isWorkflow = computed(() => pageStore.isWorkflow);
        const hasIssues = computed(() => pageStore.hasIssues);
        const adminReview = computed(() => pageStore.adminReview);
        const adminPreview = computed(() => pageStore.adminPreview);
        const title = computed(() => pageStore.title);
        const showChanges = computed(() => pageStore.showChanges);
        const visiblePages$ = computed(() => {
            const pageGroups$ = toObserverComputed(() => props.pageGroups);
            return combineLatest([pageStore.visiblePages$, pageGroups$]).pipe(map(([visiblePages, pageGroups]) => visiblePages.filter(i => pageGroups.some(j => j.pages.includes(i)))));
        });
        const visiblePages = useObservable(visiblePages$.value);
        const submittablePages = computed(() => {
            return props.pageGroups.filter(i => i.pages.some(j => !pageStore.isPageObjViewOnly(j, false))).map(i => i.pages[i.pages.length - 1]);
        });
        const hasMultiplePages = computed(() => {
            return visiblePages.value != null && visiblePages.value.length > 1;
        });
        const availableSegments = computed(() => pageStore.availableSegments);
        const activeSegments = computed(() => pageStore.activeSegments);
        const segment = computed(() => pageStore.segment);

        const isPendingAssignment = computed(() => {
            const seg = segment.value;
            const avS = availableSegments.value || [];
            const acS = activeSegments.value || [];
            //debugger;
            return avS.filter(i => props.pageGroups.some(j => j.id == i.id)).some(i => i.id == seg || seg == "NOMATCH") && !acS.filter(i => props.pageGroups.some(j => j.id == i.id)).some(i => i.id == seg || seg == "NOMATCH");
        });

        const isCurrentPageViewOnly$ = computed(() => {
            return combineLatest([currentPage$.value.pipe(switchMap(i => pageStore.isPageObjViewOnly$(i!))), toObserverComputed(() => hasIssues.value), toObserverComputed(() => isPendingAssignment.value)]).pipe(map(([pV, hI, pA]) => pV || hI || pA));
        });
        const isCurrentPageViewOnly = useObservable(isCurrentPageViewOnly$.value);
        const isWorkflowManualOverrideVisible = computed(() => {
            return !pageStore.adminPreview && adminReview.value && isWorkflow.value && pageStore.canChangeStatus;
        });
        const isWorkflowManualOverrideEnabled = computed(() => {
            return isWorkflowManualOverrideVisible.value;
        });
        const isWorkflowReturnVisible = computed(() => {
            return !pageStore.adminPreview && pageStore.adminReview && pageStore.isWorkflow && pageStore.formId != null;
        });
        const isWorkflowReturnEnabled = computed(() => {
            return isWorkflowReturnVisible.value && (!pageStore.anonymousUser || (currentSegment.value != null && currentSegment.value.definition.settings.returnEmailAddressCalculationId != null && true)) /*TODO calc returns a value*/;
        });

        const isSubmittable$ = computed(() => {
            const pageGroups = toObserverComputed(() => isPendingAssignment.value);
            return combineLatest([pageStore.isSubmittable$, pageGroups]).pipe(
                map(([a, b]) => {
                    //debugger;
                    return a && !b;
                }),
            );
        });
        const isSubmittable = useObservable(isSubmittable$.value);
        const isDeletable = computed(() => {
            return !pageStore.adminPreview && !adminReview.value && pageStore.formId != null;
        });
        const isViewOnly = computed(() => {
            return pageStore.isViewOnly || isPendingAssignment.value;
        });

        const canRetreatForm = computed(() => {
            const pages = props.pageGroups.map(i => i.pages).flat();
            if (pages == null) {
                return true;
            }
            if (currentPage.value == pages[0]) {
                return false;
            }
            return true;
        });
        const canAdvanceForm = computed(() => {
            if (isCurrentPageViewOnly.value) {
                const pages = props.pageGroups.map(i => i.pages).flat();
                if (pages == null) {
                    return true;
                }
                if (currentPage.value == pages[pages.length - 1]) {
                    return false;
                }
            }
            return true;
        });

        const showPageNav = computedAsync(async () => {
            var currentPageI = currentPage.value;
            if (currentPageI == null) {
                return true;
            }
            //@ts-expect-error
            const result = !(pageStore.mustLogin && !(await mainStore.isLoggedInPromise) && currentPageI.children.every((i: { allowAnonymous: boolean }) => i.allowAnonymous));
            emit("show-page-nav", result);
            return result;
        });

        const isCurrentPageControlsViewOnly$ = computed(() => {
            return currentPage$.value.pipe(switchMap(i => pageStore.isPageObjControlsViewOnly$(i!) || isPendingAssignment.value));
        });
        const isCurrentPageControlsViewOnly = useObservable(isCurrentPageControlsViewOnly$.value);

        const adminEditElementIds = computed(() => {
            return pageStore.adminEditElementIds;
        });
        const hasPendingAdminEdits = computed(() => {
            return adminEditElementIds.value.length > 0;
        });
        const segmentTitle = computed(() => {
            return isWorkflow.value ? currentSegmentLabel.value : title.value;
        });

        onMounted(() => {
            const resizeObserver = new ResizeObserver(entries => {
                for (let entry of entries) {
                    if (entry.contentBoxSize) {
                        const contentBoxSize = Array.isArray(entry.contentBoxSize) ? entry.contentBoxSize[0] : entry.contentBoxSize; // Firefox
                        condensed.value = contentBoxSize.inlineSize < 737;
                        buttonCondensed.value = contentBoxSize.inlineSize < 576;
                    }
                }
            });
            resizeObserver.observe(Form.value.parentElement!);
        });

        const beforeUnloadAbortController = new AbortController();
        onMounted(() => {
            window.addEventListener(
                "beforeunload",
                async () => {
                    await pageStore.abortAllPendingRequests(AbortReason.NavigatedAway, true);
                },
                { signal: beforeUnloadAbortController.signal },
            );
        });

        onBeforeUnmount(async () => {
            await pageStore.abortAllPendingRequests(AbortReason.NavigatedAway);
            beforeUnloadAbortController.abort();
        });

        onDeactivated(async () => {
            await pageStore.abortAllPendingRequests(AbortReason.NavigatedAway);
            beforeUnloadAbortController.abort();
        });

        const saveAllAdminEdits = () => {
            // Delay needed so blur runs to process textboxes value changes
            setTimeout(() => pageStore.saveAllAdminEdits(), 0);
        };
        const adjustPage = async (adjustment: number) => {
            const existingPage = page.value;
            let result = null;
            if (existingPage && !pageStore.formDataLoading) {
                if (pageStore.adminPreview || pageStore.isSaveDisabledOnSectionChange || pageStore.isClientValidationOnly) {
                    await pageStore._setPageStatus({ page: existingPage, status: null });
                } else if (!pageStore.isViewOnly && !pageStore.isPageViewOnly(existingPage)) {
                    result = alertIfSaveFailed(pageStore.saveFormPage({ page: existingPage })); // Run in the background
                }
            }
            page.value = page.value! + adjustment;
            await result;
        };
        const pageGroupStatus = (pages: PageDef[]) => {
            let status = "dfPageLink_Disabled";
            const getSegmentStatusByPage = (page: PageDef) => (pageStore.segments || []).find(segment => page.definition.settings.segment == segment.id)?.status;
            for (const page of pages) {
                const pageStatus = pageStatusFetcher()[page.vmId];
                if (!pageStatus) continue;
                if (pageStatus == "Invalid" || ["InProgress", "Returned"].includes(getSegmentStatusByPage(page) || "")) {
                    status = pageStatusClass("Invalid")!;
                    break;
                }
                status = pageStatusClass(pageStatus)!;
            }
            return status;
        };
        const togglePage = (newPage: PageDef) => {
            if (!currentPage.value) return;
            const newPageGroup = getPageGroup(newPage)!;
            const currentPageGroup = getPageGroup(currentPage.value)!;
            if (mustToggle.value || newPageGroup.id != currentPageGroup?.id) {
                togglePageHeader.value[newPageGroup.id!] = !togglePageHeader.value[newPageGroup.id!];
                if (currentPageGroup != null && newPageGroup.id != currentPageGroup.id) {
                    togglePageHeader.value[currentPageGroup.id!] = false;
                }
            }
            mustToggle.value = false;
        };
        const getPageGroup = (page: PageDef) => {
            return props.pageGroups.find(pageGroup => pageGroup.pages.some(p => p.id == page.id));
        };
        const gotoPage = async (newPage: PageDef, withError = false) => {
            await pageStore.waitForPendingVerifications();
            let result = null;
            const existingPage = page.value;
            if (existingPage && !pageStore.formDataLoading) {
                // TODO - dup with adjust page
                if (pageStore.adminPreview || pageStore.isSaveDisabledOnSectionChange || pageStore.isClientValidationOnly) {
                    await pageStore._setPageStatus({ page: existingPage, status: null });
                } else if (!pageStore.isViewOnly && !pageStore.isPageViewOnly(existingPage) && pageStore.isPageEditable(existingPage)) {
                    result = alertIfSaveFailed(pageStore.saveFormPage({ page: existingPage })); // Run in the background
                }
            }
            togglePage(newPage);
            const pagesI = pages.value;
            page.value = pagesI.indexOf(newPage) + 1;
            await result;
            focusFirstElement(withError);
        };
        const gotoSubPage = async (page: PageDef, _mustToggle = false) => {
            const existingPage = currentPage.value;
            if (existingPage != null && pages.value.indexOf(existingPage) < pages.value.indexOf(page)) {
                if (existingPage.permitLaterPages$ && !(await existingPage.permitLaterPages$().pipe(first()).toPromise()) && !isViewOnly.value && !pageStore.isPageObjViewOnly(existingPage, false)) {
                    await adjustPage(0);
                    if (existingPage.permitLaterPages$ && !(await existingPage.permitLaterPages$().pipe(first()).toPromise()) && !isViewOnly.value && !pageStore.isPageObjViewOnly(existingPage, false)) {
                        alert("You cannot advance until you correct the issues");
                        return;
                    }
                }
            }
            mustToggle.value = _mustToggle;
            gotoPage(page);
        };

        //@ts-expect-error
        eventBus.on("change-page", async ({ page, withError, callback }: { page: PageDef; withError?: boolean; callback: () => void }) => {
            await gotoPage(page, withError);
            if (callback != null) {
                callback();
            }
        });

        const gotoIndex = inject(gotoIndexInjectKey)!;
        const forceLogin = inject(forceLoginInjectKey)!;
        const submit = inject(submitInjectKey)!;
        const pageStatusFetcher = inject(pageStatusFetcherInjectKey)!;
        const submitButtons$ = inject(submitButtons$InjectKey)!;
        const submitButtons = useObservable(submitButtons$.pipe(startWith([])));
        const deleteDraft = inject(deleteDraftInjectKey)!;

        provide("getElementComponent", (type: BaseElementDefBase, viewOnly: boolean) => getElementComponent(type, viewOnly));
        provide("advanceForm", (event: Event) => advanceForm(event));
        provide("retreatForm", () => retreatForm());
        provide("gotoSubPage", (page: PageDef) => gotoSubPage(page));

        const throwIfViewOnly = () => {
            if (isViewOnly.value) {
                throw new Error("Should not be called for view only pages");
            }
        };

        const alertIfSaveFailed = async (resultPromise: Promise<null | FormJson | SaveAllAndSubmitResponse>) => {
            try {
                const result = await resultPromise;
                if (result == null) {
                    throw new Error("Null result");
                }
                return result;
            } catch (e) {
                await showModal(SaveFailureModal, {}, {});
                throw e;
            }
        };

        const saveAndExit = async () => {
            throwIfViewOnly();
            await pageStore.waitForPendingVerifications();
            const saveFormPromise = pageStore.saveFormPage({ page: page.value, isSaveAndExit: true });
            mainStore.setLiveRegion(saveFormPromise.then(() => "Details have been saved successfully"));
            await alertIfSaveFailed(saveFormPromise);
            gotoIndex();
        };

        const pageStatusClass = (clientStatus: string) => {
            return clientStatus == null ? null : clientStatus == "Complete" ? "dfPageLink_Complete" : clientStatus == "Invalid" ? "dfPageLink_Invalid" : clientStatus == "InProcess" ? "dfPageLink_InProcess" : clientStatus == "NotStarted" ? "dfPageLink_NotStarted" : clientStatus == "Saving" ? "dfPageLink_Saving" : "dfPageLink_Disabled";
        };

        const advanceForm = async (event: Event) => {
            const pages = props.pageGroups.map(i => i.pages).flat();
            if (pages == null) {
                return;
            }
            if (currentPage.value == pages[pages.length - 1]) {
                return submit(null, event);
            } else {
                const existingPage = currentPage.value;
                if (existingPage?.permitLaterPages$ && !(await existingPage.permitLaterPages$().pipe(first()).toPromise())) {
                    await adjustPage(0);
                    if (existingPage.permitLaterPages$ && !(await existingPage.permitLaterPages$().pipe(first()).toPromise())) {
                        alert("You cannot advance until you correct the issues");
                        return;
                    }
                }
                let visiblePageIndex = pages.indexOf(currentPage.value!);
                let newVisiblePage = pages[++visiblePageIndex];
                while (!(enabledPages.value ?? []).includes(newVisiblePage) && newVisiblePage != null) {
                    newVisiblePage = pages[++visiblePageIndex];
                }
                if (newVisiblePage == null) {
                    await submit(null, event);
                } else {
                    await gotoPage(newVisiblePage);
                }
            }
        };
        const retreatForm = async () => {
            const pages = props.pageGroups.map(i => i.pages).flat();
            if (pages == null) {
                return;
            }
            let visiblePageIndex = pages.indexOf(currentPage.value!);
            let newVisiblePage = pages[--visiblePageIndex];
            while (!(enabledPages.value ?? []).includes(newVisiblePage) && newVisiblePage != null) {
                newVisiblePage = pages[--visiblePageIndex];
            }
            if (newVisiblePage == null) {
                // Retreat not possible?
            } else {
                await gotoPage(newVisiblePage);
            }
        };

        const gotoAvailablePage = (page: number) => {
            return new Promise(resolve => {
                const doF = async (index: number, timeout: number) => {
                    const enabledPagesI = enabledPages.value;
                    const pagesI = pages.value;
                    if (index == 0) {
                        debugger;
                        throw new Error("Index 0");
                    }
                    if (enabledPagesI == null || pagesI == null || enabledPagesI.length == 0 || pagesI.length == 0) {
                        setTimeout(() => doF(index - 1, Math.max(timeout - 100, 100)), timeout);
                        //this.$nextTick(doF);
                        return;
                    }
                    if (page == null || page <= 0 || page > pagesI.length) {
                        page =
                            Math.max(
                                pagesI.findIndex(i => !pageStore.isPageObjViewOnly(i, false) && (enabledPages.value ?? []).includes(i)),
                                0,
                            ) + 1;
                    }
                    let pageObj = pagesI[page - 1];
                    while (!enabledPagesI.includes(pageObj) && page - 2 < pagesI.length) {
                        page++;
                        pageObj = pagesI[page - 1];
                    }
                    while (!enabledPagesI.includes(pageObj) && page > 1) {
                        page--;
                        pageObj = pagesI[page - 1];
                    }
                    if (adminReview.value) {
                        const firstPageGroupPage = pagesI.find(page => page == props.pageGroups[0].pages[0]);
                        pageObj = firstPageGroupPage == null || !enabledPagesI.includes(firstPageGroupPage) ? pageObj : firstPageGroupPage;
                    }
                    if ((enabledPages.value ?? []).includes(pageObj)) {
                        await gotoSubPage(pageObj);
                        resolve(null);
                    } else if ((enabledPages.value ?? []).some(i => i.id == pageObj.id)) {
                        nextTick(() => doF(index - 1, 100));
                    } else {
                        throw new Error("No possible pages");
                    }
                };
                doF(10, 1000);
            });
        };

        const pageStatus = (clientStatus: string) => {
            return clientStatus == "Complete" ? "Page is completed." : clientStatus == "Invalid" ? "Page has errors." : null;
        };

        const openNav = (event: Event) => {
            if (window.matchMedia("(max-width: 767px)").matches) {
                pageNavCollapsed.value = !pageNavCollapsed.value;
                if (!pageNavCollapsed.value) {
                    event.stopPropagation();
                    event.preventDefault();
                }
            }
        };

        const truncateLongText = (text: string | null) => {
            if (text == null || text.length <= 40) {
                return text;
            } else {
                return text.slice(0, 40) + "...";
            }
        };

        const focusFirstElement = async (withError: boolean) => {
            const firstElement = withError ? await currentPage.value!.firstInvalidElement(false) : currentPage.value?.firstFocusableElement();
            eventBus.emit("focus", firstElement?.vmId);
        };

        const initPageHeaderToggler = () => {
            if (Object.keys(togglePageHeader.value).length == 0) {
                togglePageHeader.value = props.pageGroups.reduce(
                    (acc, pageGroup) => {
                        acc[pageGroup.id!] = Object.keys(props.pageGroups).length > 1 ? pageGroup.pages.some(i => i == currentPage.value) : true;
                        return acc;
                    },
                    {} as Record<string, boolean>,
                );
            }
        };

        const focusPreviousTab = (event: KeyboardEvent) => {
            const currentTab = event.target as HTMLElement;
            const allTabs = Array.from(document.querySelectorAll("#PageNavigation [role='tab']"));
            const currentIndex = allTabs.indexOf(currentTab);
            const previousTab = allTabs[currentIndex - 1] || allTabs[allTabs.length - 1];
            (previousTab as HTMLElement).focus();
        };

        const focusNextTab = (event: KeyboardEvent) => {
            const currentTab = event.target as HTMLElement;
            const allTabs = Array.from(document.querySelectorAll("#PageNavigation [role='tab']"));
            const currentIndex = allTabs.indexOf(currentTab);
            const nextTab = allTabs[currentIndex + 1] || allTabs[0];
            (nextTab as HTMLElement).focus();
        };

        /*await*/ gotoAvailablePage(props.pageI);

        watch(
            () => page.value,
            newPage => {
                emit("set-page", newPage);
            },
        );

        watch(
            () => currentPage.value,
            async () => {
                if (adminPreview.value && currentPage.value?.definition.settings.segment) {
                    pageStore.setSegment(currentPage.value.definition.settings.segment);
                }
                //@ts-expect-error
                if (pageStore.mustLogin && currentPage.value != null && !currentPage.value.children.every((i: BaseFormDefinitionItem) => (i as { allowAnonymous: boolean }).allowAnonymous as boolean) && !(await mainStore.isLoggedInPromise)) {
                    forceLogin();
                }
                //TODO updateHistory();
                if (FormTitle.value) {
                    FormTitle.value.scrollIntoView(false);
                }
                initPageHeaderToggler();
                updatePage({ title: segmentTitle.value }, true);
            },
        );

        watch(
            () => segment.value,
            async () => {
                if (adminPreview.value) {
                    return;
                }
                await gotoAvailablePage(0);
            },
        );

        //TODOthis.$watch("segment", async () => {
        //TODO});

        const exposed = {
            //refs
            Form,
            FormTitle,

            //state
            pageNavCollapsed,
            page,
            formData$,
            segment,
            condensed,
            buttonCondensed,
            togglePageHeader,

            //computed
            hasPendingAdminEdits,
            segmentTitle,
            isWorkflow,
            hasIssues,
            isPendingAssignment,
            currentSegmentLabel,
            title,
            adminReview,
            adminPreview,
            hasMultiplePages,
            currentPage,
            currentSegment,
            showPageNav,
            enabledPages,
            showChanges,
            isViewOnly,
            isCurrentPageViewOnly,
            isCurrentPageControlsViewOnly,
            isWorkflowManualOverrideEnabled,
            isWorkflowManualOverrideVisible,
            isWorkflowReturnVisible,
            isWorkflowReturnEnabled,
            isSubmittable,
            isDeletable,
            canAdvanceForm,
            canRetreatForm,
            submittablePages,

            //"computed"
            pageStatusClass,
            pageStatusFetcher,
            submitButtons,
            pageStatus,

            //actions
            advanceForm,
            retreatForm,
            saveAllAdminEdits,
            openNav,
            gotoSubPage,
            submit,
            deleteDraft,
            saveAndExit,
            gotoIndex,
            truncateLongText,
            pageGroupStatus,
            focusPreviousTab,
            focusNextTab,

            // Vue-tsc workarounds
            //eslint-disable-next-line @typescript-eslint/no-explicit-any
            pageGroupCast: (i: any[]) => i as PageGroup[],
        };

        ("#if JEST");
        //@ts-ignore
        exposed.gotoPage = gotoPage;
        //@ts-ignore
        exposed.saveAndExit = saveAndExit;
        ("#endif");

        return exposed;
    },
});
</script>
